import type { CSSProperties, ReactNode } from 'react';

import type { TypeStyleName } from '../theme/typography';
import { Type } from '../theme/typography';

/**
 * The only text primitive. Mirrors android/…/Components/AppText.kt.
 *
 * Going through it means a screen cannot accidentally pick up a browser default size or colour, which is
 * how three clients drift apart.
 */
export function AppText({
  children,
  style = 'body',
  color = 'var(--text-primary)',
  align,
  as: Element = 'p',
  sx,
  id,
}: {
  children: ReactNode;
  style?: TypeStyleName;
  color?: string;
  align?: CSSProperties['textAlign'];
  as?: 'p' | 'span' | 'h1' | 'h2' | 'h3' | 'div' | 'label' | 'legend';
  sx?: CSSProperties;
  id?: string;
}) {
  return (
    <Element id={id} style={{ ...Type[style], color, textAlign: align, margin: 0, ...sx }}>
      {children}
    </Element>
  );
}
